<template>
  <div class="link_account_page">
    <Tabbar :title="$t('account.linkedAccount')"></Tabbar>
    <WithdrawStepper v-if="fromBasicLevel" />
    <div class="channel_sections">
      <!-- 已添加账户 -->
      <div class="channel_list" v-if="withdrawMethods.length > 0">
        <div class="channel_section_head">{{ $t('withdrawAccount.linkedAccount') }}</div>
        <div
          class="channel_row"
          v-for="item in withdrawMethods"
          :key="item.withdrawId || item.account + '-' + item.withdrawType"
        >
          <div class="channel_main">
            <div class="select_account_logo">
              <img
                v-if="getChannelIcon(item.withdrawType)"
                class="channel_icon"
                :src="getChannelIcon(item.withdrawType)"
                alt=""
              />
              <i v-else :class="withdrawTypeClassName[item.withdrawType]"></i>
            </div>
            <div class="account_info">
              <div class="account_name">{{ withdrawType[item.withdrawType] }}</div>
              <div class="account_sub">{{ formatAccount(item.account) }}</div>
            </div>
          </div>
          <div class="edit_btn" @click="confirm(item)">{{ $t('common.edit') }}</div>
        </div>
      </div>
      <!-- 其他可添加账户：与提现弹窗一致，不因已绑 type 隐藏；费率最低的渠道带推荐标识 -->
      <div class="channel_list" v-if="sortedBindItems.length > 0">
        <div class="channel_section_head">{{ $t('withdrawAccount.otherAccounts') }}</div>
        <div
          class="channel_row"
          v-for="(item, index) in sortedBindItems"
          :key="item.withdrawType"
        >
          <div class="channel_main">
            <div class="select_account_logo">
              <img
                v-if="getChannelIcon(item.withdrawType)"
                class="channel_icon"
                :src="getChannelIcon(item.withdrawType)"
                alt=""
              />
              <i v-else :class="withdrawTypeClassName[item.withdrawType]"></i>
            </div>
            <div class="account_info">
              <div class="account_name_row">
                <div class="account_name">{{ withdrawType[item.withdrawType] }}</div>
                <img
                  v-if="index === 0"
                  class="recommend_tag"
                  src="@/assets/recommended.png"
                  :alt="$t('withdrawAccount.recommended')"
                />
              </div>
              <div class="account_sub">{{ formatChannelFee(item.withdrawType) }}</div>
            </div>
          </div>
          <div class="edit_btn" @click="goToBindAccount(item.withdrawType)">{{ $t('common.bind') }}</div>
        </div>
      </div>
    </div>
    <CheckPayPassword :show="showKeyboard" v-bind:on-success="onPasswordSuccess" v-bind:on-close="onClose" />
    <PaymentCodeSetPopup v-model="showPaymentCodeSetPopup" :hasOldPaymentCode="hasPaymentCode" />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import WithdrawStepper from '@/components/WithdrawStepper.vue'
import Vant, { Dialog, Loading, Popup, Toast } from 'vant'
import Vue from 'vue'
import CheckPayPassword from '@/components/CheckPayPassword'
import PaymentCodeSetPopup from '@/components/PaymentCode/PaymentCodeSetPopup.vue'
import { withdrawType } from '@/utils/enum.js'
import { getChannelIcon } from '@/utils/channelIcons'

Vue.use(Dialog)
Vue.use(Vant)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Popup)

export default {
  name: 'MyLinkedAccount',
  data() {
    return {
      withdrawType,
      withdrawTypeConfigs: [],
      withdrawTypeClassName: [
        undefined,
        undefined,
        undefined,
        'icon_bank_card',
        'icon_gcash',
        'icon_paymaya',
        'icon_coins_ph',
        'icon_go_pay',
        'icon_ovo',
        'icon_dana',
        'icon_payapal',
        'icon_epay',
        'icon_e_wallet',
        'icon_qiwi',
        'usdt_epay',
        'new_icon_payapal',
        'new_icon_imps',
        'icon_upi',
        'icon_jazz_cash',
        'icon_easy_paisa',
        'new_icon_payapal'
      ],
      withdrawMethods: [],
      withdrawConfig: [],
      showKeyboard: false,
      showPaymentCodeSetPopup: false,
      hasPaymentCode: false,
      tempAccount: undefined,
      tempDocumentId: undefined,
      tempCity: undefined,
      tempPostalCode: undefined,
      tempAddressLine: undefined,
      tempWithdrawType: undefined,
      tempBankType: undefined,
      tempWithdrawId: undefined
    }
  },
  computed: {
    fromBasicLevel() {
      return this.$route.query.from === 'BasicLevel'
    },
    sortedBindItems() {
      return this.withdrawTypeConfigs.slice().sort((a, b) => {
        const feeDiff = this.getChannelFeePercent(a.withdrawType) - this.getChannelFeePercent(b.withdrawType)
        if (feeDiff !== 0) return feeDiff
        return a.withdrawType - b.withdrawType
      })
    }
  },
  created() {
    this.getWithdrawConfig()
    this.getValidWithdrawMethods()
    this.getWithdrawTypeConfigs()
  },
  components: {
    Tabbar,
    WithdrawStepper,
    CheckPayPassword,
    PaymentCodeSetPopup
  },
  methods: {
    getChannelIcon,
    onClose() {
      this.showKeyboard = false
    },
    openPaymentCodeSetPopup(hasPaymentCode) {
      this.hasPaymentCode = hasPaymentCode
      this.showPaymentCodeSetPopup = true
    },
    formatAccount(account) {
      if (account) {
        const len = account.length
        if (len > 8) {
          return account.substr(0, 4) + '****' + account.substr(len - 4, len)
        } else if (len > 4) {
          return account.substr(0, 2) + '***' + account.substr(len - 2, len)
        }
        return account
      }
      return account
    },
    formatChannelFee(type) {
      if (type === 16) {
        return this.$t('withdrawAccount.channelFee', ['3%'])
      }
      if (type === 14) {
        return this.$t('withdrawAccount.usdtFee')
      }
      const config = this.withdrawConfig.find((item) => parseInt(item.withdrawType) === type)
      if (!config || config.ratio === undefined || config.ratio === null || config.ratio === '') {
        return ''
      }
      return this.$t('withdrawAccount.channelFee', [`${config.ratio}%`])
    },
    getChannelFeePercent(type) {
      const amount = Number(this.$store.state.balance) || 0
      if (type === 16) return 3
      if (type === 14) {
        if (amount >= 100) return (2 / amount) * 100
        return Number.POSITIVE_INFINITY
      }
      const config = this.withdrawConfig.find((item) => parseInt(item.withdrawType) === type)
      if (!config || config.ratio === undefined || config.ratio === null || config.ratio === '') {
        return Number.POSITIVE_INFINITY
      }
      const ratio = Number(config.ratio)
      if (!amount) return ratio
      const walletFee = Number(config.arriPayFee) || 0
      const fee = Number(config.fee) || 0
      const minFee = Number(config.minFee) || 0
      const maxFee = Number(config.maxFee) || 0
      const applyMaxFee = (val) => (maxFee && maxFee !== 0 ? Math.min(val, maxFee) : val)
      let resFee = ((amount - walletFee) * ratio) / 100 + fee
      if (config.feeCurrency && config.feeCurrency !== 'USD') {
        const rate = Number(config.rate) || 0
        resFee = ((amount - walletFee) * rate * ratio) / 100 + fee
      }
      const total = walletFee + applyMaxFee(Math.max(resFee, minFee))
      if (!isFinite(total) || total < 0) return ratio
      return (total / amount) * 100
    },
    getWithdrawConfig() {
      const countryNo = this.$store.state.userInfo && this.$store.state.userInfo.countryNo
      if (!countryNo && countryNo !== 0) return
      this.$http
        .get(window.serverPath + '/api/withdraw/config/info?countryNo=' + countryNo)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.withdrawConfig = res.data.data || []
          }
        })
        .catch((err) => console.log(err))
    },
    getWithdrawTypeConfigs() {
      this.$http
        .get(window.serverPath + '/api/account/withdrawTypeConfigs')
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.withdrawTypeConfigs = res.data.data || []
          }
        })
        .catch((err) => console.log(err))
    },
    getValidWithdrawMethods() {
      // 获取可用的提现方式
      this.$http
        .get(window.serverPath + '/api/account/withdrawMethods')
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.withdrawMethods = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    confirm(item) {
      this.hasPayPassword().then((res) => {
        if (res) {
          // 支付密码存在
          this.showKeyboard = true
          this.tempAccount = item.account
          this.tempDocumentId = item.documentId
          this.tempCity = item.param ? item.param.city : undefined
          this.tempPostalCode = item.param ? item.param.postalCode : undefined
          this.tempAddressLine = item.param ? item.param.addressLine1 : undefined
          this.tempWithdrawType = item.withdrawType
          this.tempBankType = item.bankType
          this.tempWithdrawId = item.withdrawId
        } else {
          // 未设置支付密码
          Dialog.confirm({
            message: this.$t('withdrawAccount.payPwdRequireDialog'),
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel')
          }).then(() => {
            this.openPaymentCodeSetPopup(false)
          })
        }
      })
    },
    // 判断是否设置了支付密码
    hasPayPassword() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(window.serverPath + '/api/auth/hasPayPassword')
          .then((res) => {
            if (res.data && res.data.code === '200') {
              if (res.data.data) {
                resolve(true)
              } else {
                resolve(false)
              }
            }
            // 接口返回异常
            reject(new Error('Request failed!'))
          })
          .catch((err) => reject(err))
      })
    },
    onPasswordSuccess() {
      this.showKeyboard = false
      setTimeout(() => this.editAccount(), 100)
    },
    editAccount() {
      this.showKeyboard = false
      let name = ''
      switch (this.tempWithdrawType) {
        case 3:
          name = 'EditBankAccount'
          break
        case 4:
          name = 'EditGcashAccount'
          break
        case 7:
          name = 'EditGoPayAccount'
          break
        case 8:
          name = 'EditOVOAccount'
          break
        case 9:
          name = 'EditDANAAccount'
          break
        case 10:
          name = 'EditPayPalAccount'
          break
        case 11:
          name = 'EditEPayAccount'
          break
        case 12:
          name = 'EditEWalletAccount'
          break
        case 13:
          name = 'EditQiwiAccount'
          break
        case 14:
          name = 'EditUSDTAccount'
          break
        case 15:
          name = 'EditNewPayPalAccount'
          break
        case 16:
          name = 'EditNewIMPS'
          break
        case 17:
          name = 'EditUPIAccount'
          break
        case 18:
          name = 'EditJazzCash'
          break
        case 19:
          name = 'EditEasyPaisa'
          break
        case 20:
          name = 'EditPayoutPayPalAccount'
          break
        default:
          break
      }
      this.$router.push({
        name,
        params: {
          account: this.tempAccount,
          documentId: this.tempDocumentId,
          city: this.tempCity,
          postalCode: this.tempPostalCode,
          addressLine: this.tempAddressLine,
          bankType: this.tempBankType,
          withdrawType: this.tempWithdrawType,
          withdrawId: this.tempWithdrawId
        }
      })
    },
    goToBindAccount(withdrawType) {
      console.log(withdrawType, 'withdrawType')
      if (this.$store.state.userInfo.level === 0) {
        Dialog.alert({
          message: this.$t('withdrawAccount.noBasicLevelVerificationDialog'),
          confirmButtonText: this.$t('common.confirm')
        }).then(() => {
          this.$router.push({
            name: 'BasicLevel',
            query: { ...this.$route.query }
          })
        })
        return
      }
      let name = ''
      switch (withdrawType) {
        case 3:
          name = 'BindBankAccount'
          break
        case 4:
          name = 'BindGcashAccount'
          break
        case 7:
          name = 'BindGoPayAccount'
          break
        case 8:
          name = 'BindOVOAccount'
          break
        case 9:
          name = 'BindDANAAccount'
          break
        case 10:
          name = 'BindPayPalAccount'
          break
        case 11:
          name = 'BindEPayAccount'
          break
        case 12:
          name = 'BindEWalletAccount'
          break
        case 13:
          name = 'BindQiwiAccount'
          break
        case 14:
          name = 'BindUSDTAccount'
          break
        case 15:
          name = 'BindNewPayPal'
          break
        case 16:
          name = 'BindNewIMPS'
          break
        case 17:
          name = 'BindUPIAccount'
          break
        case 18:
          name = 'BindJazzCash'
          break
        case 19:
          name = 'BindEasyPaisa'
          break
        case 20:
          name = 'BindPayoutPayPal'
          break
        default:
          break
      }
      console.log({ name, query: { ...this.$route.query } })
      this.$router.push({ name, query: { ...this.$route.query } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.link_account_page {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 0;
  padding: 0 0.16rem 0.16rem;
}

.link_account_page .withdraw_stepper {
  margin: 0 -0.16rem;
  width: calc(100% + 0.32rem);
}

.link_account_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.channel_sections {
  display: flex;
  flex-direction: column;
  gap: 0.13rem;
  padding-top: 0.16rem;
}

.channel_list {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
  border-radius: 0.16rem;
  background: #f9f9f9;
}

.channel_section_head {
  width: 100%;
  padding: 0.12rem 0;
  border-bottom: 0.01rem solid #e4e4e4;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.2rem;
  text-align: start;
}

.channel_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.12rem;
  width: 100%;
  height: 0.6rem;
  flex-shrink: 0;
}

.channel_main {
  display: flex;
  flex: 1;
  align-items: center;
  gap: 0.16rem;
  min-width: 0;
}

.select_account_logo {
  width: 0.36rem;
  height: 0.28rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.select_account_logo i,
.channel_icon {
  width: 0.36rem;
  height: 0.28rem;
  display: block;
  object-fit: contain;
}

.bank_card_icon {
  width: 0.22rem;
  height: 0.22rem;
  display: block;
  transform: rotate(90deg);
}

.account_info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  text-align: start;
}

.account_name_row {
  display: flex;
  align-items: center;
  gap: 0.03rem;
  min-width: 0;
}

.account_name {
  margin-bottom: -0.02rem;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.24rem;
}

.recommend_tag {
  flex-shrink: 0;
  width: 0.18rem;
  height: 0.18rem;
  display: block;
}

.account_sub {
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.edit_btn {
  height: 0.24rem;
  padding: 0 0.08rem;
  border-radius: 0.04rem;
  background: rgba(63, 187, 112, 0.1);
  color: #3fbb70;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.select_account {
  flex: auto;
  color: #252525;
  font-size: 0.16rem;
  text-align: right;
}

.select_account_arrow {
  flex: none;
  box-sizing: border-box;
}

.unbind_btn {
  display: block;
  height: 0.24rem;
  background: #378e5b;
  color: #fff;
  border-radius: 0.365rem;
  margin-inline-start: 0.08rem;
  font-size: 0.14rem;
  line-height: 0.24rem;
  padding: 0 0.08rem;
  font-weight: 500;
}

.done_btn_area {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.86rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eeeef7;
  background: #ffffff;
}

.done_btn {
  width: 3.38rem;
  height: 0.5rem;
  color: #fff;
  font-size: 0.16rem;
  text-align: center;
  line-height: 0.5rem;
  border-radius: 0.5rem;
  background-color: #378e5b;
}

.icon_bank_card {
  background: url('../assets/channels/property_1_.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_gcash {
  background: url('../assets/channels/property_1_gcash.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_go_pay {
  background: url('../assets/channels/property_1_gopay.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_ovo {
  background: url('../assets/channels/property_1_ovo.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_dana {
  background: url('../assets/channels/property_1_dana.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_payapal {
  background: url('../assets/channels/property_1_paypal.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_epay {
  background: url('../assets/channels/property_1_epay.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.new_icon_payapal {
  background: url('../assets/new_paypal_logo.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.new_icon_imps {
  background: url('../assets/channels/property_1_imps.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_upi {
  background: url('../assets/channels/property_1_upi.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_jazz_cash {
  background: url('../assets/channels/property_1_jazz_cash.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_easy_paisa {
  background: url('../assets/channels/property_1_easypaisa.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.usdt_epay {
  background: url('../assets/channels/property_1_usdt.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.icon_e_wallet::after {
  content: 'Mobile Money';
  display: flex;
  width: 200%;
  height: 100%;
  color: #378e5b;
  font-size: 0.18rem;
  justify-content: start;
  align-items: center;
  font-weight: 900;
}

.icon_qiwi {
  background: url('../assets/channels/property_1_qiwi.png') no-repeat center;
  background-size: 0.36rem 0.28rem;
}

.add-btn {
  color: #fff;
  font-size: 0.16rem;
  padding: 0.06rem 0.12rem;
  background: #378e5b;
  border-radius: 0.365rem;
}

.done_btn_area {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.86rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eeeef7;
  padding: 0.18rem;
  background: #ffffff;
}

.done_btn {
  width: 100%;
  height: 0.5rem;
  color: #fff;
  font-size: 0.16rem;
  text-align: center;
  line-height: 0.5rem;
  border-radius: 0.5rem;
  background-color: #378e5b;
}

.account_icon {
  width: 0.46rem;
  height: 0.6rem;
}
</style>



// WEBPACK FOOTER //
// src/views/MyLinkedAccount.vue